"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const useState_1 = require("../../../../hooks/useState");
exports.default = (0, vue_1.defineComponent)({
    __name: 'state-field',
    emits: ["change"],
    setup(__props, { emit }) {
        const { fetch } = (0, useState_1.useState)();
        const input = (0, vue_2.ref)(0);
        const states = (0, vue_2.ref)(null);
        (0, vue_2.onMounted)(async () => {
            states.value = await fetch();
        });
        (0, vue_2.watch)(input, () => {
            emit("change", Number(input.value));
        });
        return { __sfc: true, fetch, input, states, emit };
    }
});
